import React from 'react'
import IndividualTaskList from '../../features/IndividualMemberTaskList/IndividualTaskList'

const IndividualMemberTaskList = () => {
    return (
        <IndividualTaskList />
    )
}

export default IndividualMemberTaskList